import { useKitData } from "@/data/use-kits-data";
import { useGroupUuid } from "@/hooks/use-group-uuid";
import { Kit } from "@/types/types";
import { KitQuickSettingsUI } from "./KitQuickSettingsUI";

type BasicKitQuickSettingsProps = {
  kit: Kit;
};

export const BasicKitQuickSettings = ({ kit }: BasicKitQuickSettingsProps) => {
  const groupUuid = useGroupUuid();
  const { updateKit } = useKitData(groupUuid, kit.uuid);

  return (
    <KitQuickSettingsUI
      kit={kit}
      onNameChange={(name) => updateKit({ name })}
    />
  );
};
